<nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton>
<div class="atp-report" *ngIf="adocRows !== undefined && !isLoading">

  <nz-table #adocTable [nzData]="adocRows" nzBordered>
    <thead>
      <tr>
        <th></th>
        <th>Instance</th>
        <!-- <th>DocEntry</th> -->
        <th>Object Code</th>
        <th>Updated</th>
        <th>Updated By - User Code</th>
        <th>Updated By - User Name</th>
        <th>Updated On/At</th>
        <th>Created</th>
        <th>Created On/At</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of adocTable.data">
        <td>
          <input type="checkbox" [checked]="isSelected(row)" (change)="onCheckboxChange($event, row)" />
        </td>
        <td>
          <a (click)="openLogRecord(row)">
            {{ row.LogInstanc }}
          </a>
        </td>
        <!-- <td>{{ row.DocEntry }}</td> -->
        <td>{{ row.DocNum }}</td>
        <td>{{ row.UpdateDate }}</td>
        <td>{{ row.USER_CODE }}</td>
        <td>{{ row.U_NAME }}</td>
        <td>{{ row.UpdateDateTime }}</td>
        <td>{{ row.CreateDate }}</td>
        <td>{{ row.CreateDateTime }}</td>
      </tr>
    </tbody>
  </nz-table>

  <button nz-button [nzType]="'primary'"
    [disabled]="!(selectedRows.length === 2 || selectedRows.length === 1) || (selectedRows.length === 1 && selectedRows[0].LogInstanc === adocRows.length)"
    (click)="processSelectedRows()" style="margin-top: 16px;">
    Show Differences
  </button>

</div>
